import React from 'react'
import BaseWidgetProvider from '../../base/BaseWidgetProvider'
import CropRotateIcon from '@mui/icons-material/CropRotate'
import ActiveSingleJobContainer from './ActiveSingleJobContainer'

class ActiveSingleJobWidgetProvider extends BaseWidgetProvider {
  getCode = () => 'ActiveSingleJobWidget'
  getName = () => 'Active Single Job'
  getIcon = () => CropRotateIcon
  createWidget = (props) => <ActiveSingleJobContainer {...props} />

  // Custom header if needed, otherwise default
  // getCustomHeader = (props) => ...

  size = { defaultW: 4, defaultH: 6, minW: 3, minH: 6 }

  getWidgetInfo = (columns, cellHeight) => {
    return { ...super.getWidgetInfo(columns, cellHeight, this.size) }
  }
}

export default ActiveSingleJobWidgetProvider
